
export {
  filterUnusedRoles,
  getSignups,
  getNumberOfSignups,
  getSpecSortSequence,
}

// Takes the array of all roles and returns the array of roles that have signups
function filterUnusedRoles(roles, signups) {
  var result = [];

  // Go through all the roles and see which have signups
  for (var role of roles) {
    var newrole = {
      name: role.name, specs: [],
      desiredcolumns10: role.desiredcolumns10,
      desiredcolumns25: role.desiredcolumns25
    };
    var specsfound = 0;

    // Check which specs have signups
    for (var spec of role.specs) {
      var found = -1 != signups.findIndex(s => s.spec == spec);
      if (found) {
        newrole.specs.push(spec);
        specsfound++;
      }
    }

    // Only add the role to the array if it has any specs
    if (specsfound > 0) {
      result.push(newrole);
    }
  }

  return result;
}

function getSignups(signups, raidevent, team, state) {
  return signups.filter(s => s.eventid == raidevent['.key']
    && (s.team && team && s.team == team['.key']
      || s.team == null
      && team == null)
    && (s.state == state
      || s.state == null
      && state == 'Unplanned'
      && !s.absent))
}

function getNumberOfSignups(signups, raidevent, team, state) {
  var filteredSignups = getSignups(signups, raidevent, team, state)
  return filteredSignups.length;
}

function getSpecSortSequence( specs, spec ) {   
  const index = specs.findIndex(s => s.name == spec);
  if (index >= 0) {
    return index;
  }
  return 9999;
}
